var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterTimeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7516 4.75C6.7516 4.33579 6.41581 4 6.0016 4C5.58739 4 5.2516 4.33579 5.2516 4.75V17.44L3.53019 15.7195C3.23722 15.4267 2.76234 15.4268 2.46953 15.7198C2.17671 16.0128 2.17684 16.4877 2.46981 16.7805L5.47141 19.7805C5.6121 19.9211 5.80289 20.0001 6.0018 20C6.20071 19.9999 6.39146 19.9209 6.53207 19.7802L9.53047 16.7802C9.82329 16.4872 9.82316 16.0123 9.53019 15.7195C9.23722 15.4267 8.76234 15.4268 8.46953 15.7198L6.7516 17.4387V4.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 6C11.3358 6 11 6.33579 11 6.75C11 7.16421 11.3358 7.5 11.75 7.5H20.25C20.6642 7.5 21 7.16421 21 6.75C21 6.33579 20.6642 6 20.25 6H11.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.25C13.3358 11.25 13 11.5858 13 12C13 12.4142 13.3358 12.75 13.75 12.75H20.25C20.6642 12.75 21 12.4142 21 12C21 11.5858 20.6642 11.25 20.25 11.25H13.75Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 16.5C15.3358 16.5 15 16.8358 15 17.25C15 17.6642 15.3358 18 15.75 18H20.25C20.6642 18 21 17.6642 21 17.25C21 16.8358 20.6642 16.5 20.25 16.5H15.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTimeline);
export default __webpack_public_path__ + "static/media/filter-timeline.e58fb2d1be05427d26fd3e54bf4bca10.svg";
export { ForwardRef as ReactComponent };